import * as actionType from "./constants";

const initialState = {
    getChartCategoriesResponse: { isLoading: false, categories: [], count: 0 },
    saveChartCategoriesResponse: { isLoading: false }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_CHART_CATEGORIES_REQUEST:
            return { ...state, getChartCategoriesResponse: { ...state.getChartCategoriesResponse, isLoading: true } };
        case actionType.GET_CHART_CATEGORIES_SUCCESS:
            return { ...state, getChartCategoriesResponse: { isLoading: false, success: true, categories: [], count: 0, ...action.response } };
        case actionType.GET_CHART_CATEGORIES_FAILURE:
            return { ...state, getChartCategoriesResponse: { isLoading: false, success: false, categories: [], count: 0, ...action.error } };

        case actionType.SAVE_CHART_CATEGORIES_REQUEST:
            return { ...state, saveChartCategoriesResponse: { isLoading: true } };
        case actionType.SAVE_CHART_CATEGORIES_SUCCESS:
            return { ...state, saveChartCategoriesResponse: { isLoading: false, success: true, ...action.response } };
        case actionType.SAVE_CHART_CATEGORIES_FAILURE:
            return { ...state, saveChartCategoriesResponse: { isLoading: false, success: false, ...action.error } };

        default:
            return state;
    }
};
